<div class="widget-area">
  <div class="widget-archives footer-widget mb-50">
    <h3 class="widget-title">About Us</h3>
    <ul>
      <li class="menu-item-has-children" routerLinkActive="active">
        <ul class="sub-menu">

          <li><a routerLink="/about/sri-balaji-educational-society" routerLinkActive="active">Society</a></li>
          <li><a routerLink="/about/founder" routerLinkActive="active">Founder</a></li>
          <li><a routerLink="/about/chairman" routerLinkActive="active">Chairman</a></li>
          <li><a routerLink="/about/treasurer" routerLinkActive="active">Treasurer</a></li>
          <li><a routerLink="/about/management" routerLinkActive="active">Management Team</a></li>
          <li><a routerLink="/about/faqs" routerLinkActive="active">FAQs</a></li>
        </ul>
      </li>
    </ul>
  </div>
</div>
